/* eslint-disable */
/*
    CTC - Modeller Data 1.4.16.0
    DataSet Date: 09/11/2018
*/

var ctcProductChargesJSON = { "productCharge":
	{ "tiers": [
        {
            "maxThreshold": "24999.99",
            "rate": "0.45"
        }, {
            "maxThreshold": "49999.99",
            "rate": "0.45"
        }, {
            "maxThreshold": "99999.99",
            "rate": "0.45"
        }, {
            "maxThreshold": "249999.99",
            "rate": "0.4"
        }, {
            "maxThreshold": "499999.99",
            "rate": "0.35"
        }, {
            "maxThreshold": "749999.99",
            "rate": "0.3"
        }, {
            "maxThreshold": "999999.99",
            "rate": "0.275"
        }, {
            "maxThreshold": "9999999999.99",
            "rate": "0.25"
        }
    ]}
}

var ctcTaxDetailsJSON = { "taxDetails":[
    {
        "effectiveDate" : "2019-04-06",
        "inflationRate" : "2.0"
    },{
        "effectiveDate" : "2018-04-06",
        "inflationRate" : "2.5"
    }]}

module.exports = {
    ctcProductChargesJSON: ctcProductChargesJSON,
    ctcTaxDetailsJSON: ctcTaxDetailsJSON
};



// WEBPACK FOOTER //
// ./src/calculator/ctcProductData.js